import { ColaboradorList } from "../../../enums/tipo-vinculo.enum"
import { FieldError, formSelectClass } from "@/shared/components/forms/FormFieldFeedback";
import { PersonFormValues } from "@/modules/people/presentation/person.schema";
import { PersonProfilesFormMethods } from "./profile.types"
import { useFormState } from "react-hook-form";
import { Controller } from "react-hook-form"
import { useEffect, useState } from "react"
import { Tabs, Tab } from "react-bootstrap"
import { readFuncao } from "@/modules/structure/funcao/funcao.service"
import { LotacaoService } from "@/modules/business/lotacoes/lotacao.service"
import { ReadLotacaoDto } from "@/api.types"
import { SearchDtoLotacoes } from "@/shared/types/search.dto"
import GerenciarVinculosDefensoresModal from "../../modals/GerenciarVinculosDefensoresModal"
import { VinculoDefensorAssessorFormDto } from "@/modules/people/presentation/person-form.utils"
import { LotacoesPerfilTable } from "./lotacoes-perfil-table"
import { EstagiariosResponsavelLista } from "./estagiarios-responsavel-lista"

interface Funcao {
  id: number
  nome: string
}

interface ColaboradorProfileFieldsProps {
  methods: PersonProfilesFormMethods
}

export function ColaboradorProfileFields({ methods }: ColaboradorProfileFieldsProps) {
  const { errors } = useFormState<PersonFormValues>();
  const colaboradorId = methods.watch('colaborador.id')
  const pessoaId = methods.watch('id')
  const vinculosDefensores = (methods.watch('colaborador.vinculosDefensores') ?? []) as VinculoDefensorAssessorFormDto[]
  const [funcoes, setFuncoes] = useState<Funcao[]>([])
  const [lotacoesAtuais, setLotacoesAtuais] = useState<ReadLotacaoDto[]>([])
  const [modalVinculosShow, setModalVinculosShow] = useState(false)

  const hoje = new Date().toISOString().slice(0, 10)
  const vinculoAtual = vinculosDefensores.find((vinculo) => {
    const inicio = String(vinculo.data_inicial ?? '').slice(0, 10)
    const fim = vinculo.data_final ? String(vinculo.data_final).slice(0, 10) : null
    return inicio && inicio <= hoje && (!fim || fim >= hoje)
  })

  useEffect(() => {
    readFuncao({ take: 1000, orderBy: 'ASC', orderField: 'nome' })
      .then(([data]) => setFuncoes(data))
      .catch(() => setFuncoes([]))
  }, [])

  const recarregarLotacoes = () => {
    if (!colaboradorId) {
      setLotacoesAtuais([]);
      return;
    }
    const lotacaoService = new LotacaoService();
    const searchParams: SearchDtoLotacoes = {
      skip: 0,
      take: 9000,
      id_colaborador: colaboradorId,
    } as SearchDtoLotacoes;

    lotacaoService
      .Enumerate(searchParams)
      .then((result) => {
        setLotacoesAtuais(result[0]);
      })
      .catch((error) => {
        console.warn('Erro ao carregar lotações:', error);
      });
  };

  useEffect(() => {
    recarregarLotacoes();
  }, [colaboradorId]);

  return (
    <div className="row">
      <div className="col-md-9">
        <div className="row">
          <div className="form-group mb-3 col-md-3">
            <label htmlFor="colaborador_tipo_vinculo">
              Tipo de Vínculo<span className="text-danger"> *</span>
            </label>
            <select
              id="colaborador_tipo_vinculo"
              className={formSelectClass(!!errors.colaborador?.tipo_vinculo)}
              {...methods.register('colaborador.tipo_vinculo')}
            >
              {ColaboradorList.map(item => (
                <option key={item.value} value={item.value}>{item.name}</option>
              ))}
            </select>
            <FieldError message={errors.colaborador?.tipo_vinculo?.message} />
          </div>

          <div className="col-md-4">
            <label htmlFor="colaborador_funcao" className="form-label">Função:</label>
            <Controller
              name="colaborador.funcao.id"
              control={methods.control}
              render={({ field }) => (
                <select
                  id="colaborador_funcao"
                  className="form-select"
                  value={field.value || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    field.onChange(value === '' ? null : Number(value));
                  }}
                  onBlur={field.onBlur}
                >
                  <option value="">Selecione uma função</option>
                  {funcoes.map(funcao => (
                    <option key={funcao.id} value={funcao.id}>{funcao.nome}</option>
                  ))}
                </select>
              )}
            />
          </div>

          <div className="col-md-5">
            <label htmlFor="colaborador_orgao_origem" className="form-label">Órgão de Origem/Empresa:</label>
            <input
              id="colaborador_orgao_origem"
              type="text"
              className="form-control"
              {...methods.register('colaborador.orgao_origem')}
            />
          </div>

          <div className="col-md-3">
            <div className="form-check ms-3 mt-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="colaborador_vinculo_direto"
                {...methods.register("colaborador.vinculo_direto")}
              />
              <label className="form-check-label" htmlFor="colaborador_vinculo_direto">
                Vínculo Direto
              </label>
            </div>

            <div className="form-check ms-3 mt-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="colaborador_cessao_onerosa"
                {...methods.register("colaborador.cessao_onerosa")}
              />
              <label className="form-check-label" htmlFor="colaborador_cessao_onerosa">
                Cessão Onerosa
              </label>
            </div>

            <div className="form-check ms-3 mt-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="colaborador_permite_editar_relatorio_defensor"
                {...methods.register("colaborador.permite_editar_relatorio_defensor" as any)}
              />
              <label className="form-check-label" htmlFor="colaborador_permite_editar_relatorio_defensor">
                Permite editar relatório de defensor
              </label>
            </div>
          </div>

          <div className="col-md-4">
            <label htmlFor="colaborador_anotacao" className="form-label">Anotações:</label>
            <input id="colaborador_anotacao" type="text" className="form-control" {...methods.register('colaborador.anotacao')} />
          </div>

          <div className="col-md-5">
            <label htmlFor="colaborador_defensor_vinculado" className="form-label mb-1">Defensor(a):</label>
            <div className="input-group">
              <input
                id="colaborador_defensor_vinculado"
                type="text"
                className="form-control"
                readOnly
                value={vinculoAtual?.defensor_nome?.trim()}
              />
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => setModalVinculosShow(true)}
              >
                Editar
              </button>
            </div>
          </div>

        </div>
      </div>

      <div className="col-md-3">
        <div className="card">
          <div className="card-body">
            <div className="mb-3">
              <label htmlFor="colaborador_data_cessao" className="form-label">Data Cessão/Início:</label>
              <input
                id="colaborador_data_cessao"
                type="date"
                className="form-control"
                {...methods.register('colaborador.data_cessao')}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="colaborador_data_saida" className="form-label">Data Saída:</label>
              <input
                id="colaborador_data_saida"
                type="date"
                className="form-control"
                {...methods.register('colaborador.data_saida')}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 mt-3">
        <Tabs
          defaultActiveKey="lotacoes"
          id="colaborador-perfil-tabs"
          className="mb-2"
          mountOnEnter
          unmountOnExit
        >
          <Tab eventKey="lotacoes" title="Lotações">
            <LotacoesPerfilTable
              lotacoes={lotacoesAtuais}
              emptyMessage="Nenhuma lotação cadastrada para este colaborador."
              tipoPessoa="colaborador"
              pessoaLotadaId={colaboradorId}
              onRecarregar={recarregarLotacoes}
            />
          </Tab>

          <Tab eventKey="estagiarios" title="Estagiários">
            <EstagiariosResponsavelLista
              pessoaId={pessoaId}
              emptyMessage="Nenhum estagiário com lotação vigente sob responsabilidade deste colaborador."
            />
          </Tab>
        </Tabs>
      </div>

      <GerenciarVinculosDefensoresModal
        show={modalVinculosShow}
        handleHide={() => setModalVinculosShow(false)}
        vinculos={vinculosDefensores}
        setValue={methods.setValue}
      />
    </div>
  )
}

/** @deprecated Use OperationalProfilesSection */
export function ColaboradorProfile({
  methods,
  podeVerColaborador,
}: {
  methods: PersonProfilesFormMethods;
  podeVerColaborador: boolean;
}) {
  if (!podeVerColaborador) return null;
  return <ColaboradorProfileFields methods={methods} />;
}
